
import { 
    SAVE_REFERENCES,
    SAVE_REFERENCES_SUCCESS,
    SAVE_REFERENCES_FAIL, 
    SAVE_REFERENCES_RESET,
} from "../actions/saveReferencesAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const saveReferencesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_REFERENCES:
            return {
                ...state,
                apiState: "loading",
            };
        case SAVE_REFERENCES_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case SAVE_REFERENCES_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case SAVE_REFERENCES_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default saveReferencesReducer;
